module.exports = __webpack_public_path__ + "img/gift.fdaacaf8.svg";